export enum CourseTranslationTags {
  CourseName = "course_name",
}

export enum PreAssessmentReportTranslationTags {
  Title = "pre_assessment_title",
  ParticipantLabel = "pre_assessment_participant_label",
  CourseLabel = "pre_assessment_course_label",
  ScoreLabel = "pre_assessment_score_label",
  QuestionHeader = "pre_assessment_question_header",
  YourAnswerHeader = "pre_assessment_your_answer_header",
  CorrectAnswerHeader = "pre_assessment_correct_answer_header",
  ResultHeader = "pre_assessment_result_header",
  ResultCorrect = "pre_assessment_result_correct",
  ResultWrong = "pre_assessment_result_wrong",
}

export const PreAssessmentReportTranslationLabels: { [tag: string]: string } = {
  [PreAssessmentReportTranslationTags.Title]: "Title",
  [PreAssessmentReportTranslationTags.ParticipantLabel]: "Participant label",
  [PreAssessmentReportTranslationTags.CourseLabel]: "Course label",
  [PreAssessmentReportTranslationTags.ScoreLabel]: "Score label",
  [PreAssessmentReportTranslationTags.QuestionHeader]: "Table header - Question",
  [PreAssessmentReportTranslationTags.YourAnswerHeader]: "Table header - Your Answer",
  [PreAssessmentReportTranslationTags.CorrectAnswerHeader]: "Table header - Correct Answer",
  [PreAssessmentReportTranslationTags.ResultHeader]: "Table header - Result",
  [PreAssessmentReportTranslationTags.ResultCorrect]: "Result value - Correct",
  [PreAssessmentReportTranslationTags.ResultWrong]: "Result value - Wrong",
};
